export const noti = {
    text1: "Notifications",
    text2: "List of notifications.",
    text3: "You have no notifications",
};